export default "__VITE_ASSET__TuakId$o__"